import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "antd/lib/card";

import { IconSend } from "@tabler/icons-react";

import styles from "./ready-to-send-card.module.css";

export default function ReadyToSendCard({ selectedRegions, handleSubmit, loading }) {
    return (
        <Card className={styles.actionCard}>
          <div className={styles.actionContent}>
            <div className={styles.actionInfo}>
              <Typography variant="h6">Ready to Send</Typography>
              <Typography variant="body2" color="textSecondary">
                {selectedRegions.length} regions selected
              </Typography>
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={loading.sending}
              startIcon={<IconSend />}
              className={styles.submitButton}
            >
              Send Storm Strategies
            </Button>
          </div>
        </Card>
    )
}